import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  FormGroup,
  Row,
} from 'reactstrap';

import OtoSpinner from '../common/OtoSpinner';
import { IPlace } from 'types/restaurant-place';
import Shapes from 'shapes/main';
import OtoToggle from '../common/OtoToggle';

interface IProps {
  selectedPlace: IPlace | null;
  setSelectedPlace: (place: IPlace | null) => void;
  onSave: (selectedPlace: IPlace) => void;
  loading: boolean;
}

const PlaceEditModal: React.FC<IProps> = (props) => {
  const { selectedPlace, setSelectedPlace, onSave, loading } = props;
  const clearSelectedPlace = () => setSelectedPlace(null);

  return (
    <Modal isOpen={!!selectedPlace} toggle={clearSelectedPlace}>
      {selectedPlace && (
        <>
          <ModalHeader toggle={clearSelectedPlace}>
            {i18next.t('place-edit-modal.editing-place', { name: selectedPlace.name })}
          </ModalHeader>
          <ModalBody>
            <FormGroup className="mw-300">
              <Label>{i18next.t('place-edit-modal.room-name')}</Label>
              <Input
                placeholder={i18next.t('place-edit-modal.room-name-placeholder')}
                value={selectedPlace.name}
                onChange={(e) =>
                  setSelectedPlace({ ...selectedPlace, name: e.target.value })
                }
              />
            </FormGroup>
            <FormGroup className="mw-150">
              <Label>{i18next.t('place-edit-modal.priority')}</Label>
              <Input
                placeholder={i18next.t('place-edit-modal.priority-placeholder')}
                value={selectedPlace.priority}
                onChange={(e) =>
                  setSelectedPlace({
                    ...selectedPlace,
                    // @ts-ignore allow empty string in edit mode
                    priority: e.target.value
                      ? parseInt(e.target.value, 10)
                      : '',
                  })
                }
                step="1"
                min="1"
                type="number"
              />
            </FormGroup>
            <Row>
              <FormGroup className="col-12 col-md-6">
                <Label>{i18next.t('place-edit-modal.is-active')}</Label>
                <OtoToggle
                  className="mr-2 d-flex flex-row"
                  checked={selectedPlace.is_active}
                  id="isPlaceActive"
                  name="isPlaceActive"
                  onChange={(e) =>
                    setSelectedPlace({
                      ...selectedPlace,
                      is_active: e.target.checked,
                    })
                  }
                />
              </FormGroup>
              <FormGroup className="col-12 col-md-6">
                <Label>{i18next.t('place-edit-modal.is-outside')}</Label>
                <OtoToggle
                  className="mr-2 d-flex flex-row"
                  checked={selectedPlace.is_outside}
                  id="isPlaceOutside"
                  name="isPlaceOutside"
                  onChange={(e) =>
                    setSelectedPlace({
                      ...selectedPlace,
                      is_outside: e.target.checked,
                    })
                  }
                />
              </FormGroup>
            </Row>
          </ModalBody>
        </>
      )}
      <ModalFooter>
        {loading ? (
          <OtoSpinner />
        ) : (
          <Button
            type="button"
            color="primary"
            onClick={() => onSave(selectedPlace as IPlace)}
          >
            {i18next.t('Save')}
          </Button>
        )}
        <Button type="button" onClick={clearSelectedPlace}>
          {i18next.t('Cancel')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

PlaceEditModal.propTypes = {
  loading: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  selectedPlace: Shapes.restaurantPlaceShape.isRequired,
  setSelectedPlace: PropTypes.func.isRequired,
};

export default PlaceEditModal;
